export type UserState = {
  adminRole: boolean
}

export const initialUserState: UserState = {
  adminRole: false,
}
